"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dutiesRequestToDuties = exports.IncotermRequest = exports.MerchantOfRecordProvider = exports.Incoterm = void 0;
var Incoterm;
(function (Incoterm) {
    Incoterm["DDU"] = "DDU";
    Incoterm["DDP"] = "DDP";
})(Incoterm = exports.Incoterm || (exports.Incoterm = {}));
var MerchantOfRecordProvider;
(function (MerchantOfRecordProvider) {
    MerchantOfRecordProvider["GLOBALE"] = "GLOBALE";
    MerchantOfRecordProvider["MARKETS_PRO"] = "MARKETS_PRO";
})(MerchantOfRecordProvider = exports.MerchantOfRecordProvider || (exports.MerchantOfRecordProvider = {}));
var IncotermRequest;
(function (IncotermRequest) {
    IncotermRequest["DAP"] = "DAP";
    IncotermRequest["DDU"] = "DDU";
    IncotermRequest["DDP"] = "DDP";
})(IncotermRequest = exports.IncotermRequest || (exports.IncotermRequest = {}));
const dutiesRequestToDuties = (duties) => {
    return {
        incoterm: duties.incoterm ? IncotermMap[duties.incoterm] : undefined,
        merchantOfRecordProvider: duties.merchantOfRecordProvider,
        merchantOfRecordAccountId: duties.merchantOfRecordAccountId,
        merchantOfRecordOrderId: duties.merchantOfRecordOrderId,
        merchantOfRecordSkuMap: duties.merchantOfRecordSkuMap,
        merchantOfRecordShippingMethod: duties.merchantOfRecordShippingMethod,
    };
};
exports.dutiesRequestToDuties = dutiesRequestToDuties;
const IncotermMap = {
    [IncotermRequest.DAP]: Incoterm.DDU,
    [IncotermRequest.DDU]: Incoterm.DDU,
    [IncotermRequest.DDP]: Incoterm.DDP,
};
//# sourceMappingURL=Duties.js.map